// extracted by css-extract-rspack-plugin
export default {"rootBesidePane":"wMsGMul01uwLhNaM","containerBesidePane":"x1w2xCQNgVwoFI28"};